import React from 'react';
import { NewsHeader } from './elements/NewsHeader';
import { FeaturedNews } from './elements/FeaturedNews';
import { AllNews } from './elements/AllNews';
import { NewsletterSubscribe } from './elements/NewsletterSubscribe';

const NewsPage: React.FC = () => {
  return (
    <div className="bg-white min-h-screen">
      <NewsHeader />
      <FeaturedNews />
      <div className="my-16">
        <NewsletterSubscribe />
      </div>
      <AllNews />
    </div>
  );
};

export default NewsPage;
